import React from 'react';
import { Loader, TableFilter, BaasicTable, BaasicHeader } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const ReturnAddressListTemplate = ({
	viewStore,
	viewStore: { loading, listStore, tableData, queryUtility },
	headerCell,
	actions,
}) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.ADMINISTRATION.RETURNADDRESS"></BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					viewStore,
					headerCell,
					actions,
				}}
				data={listStore.data.slice()}
			/>
		</section>
	);
};

export default defaultTemplate(ReturnAddressListTemplate);
